import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { Suspense, useEffect, lazy } from 'react'
import { useDispatch } from 'react-redux'
import { Action, Dispatch } from 'redux'
import AuthLayout from '../components/Layout/Auth'
import ScrollToTop from '../components/ScrollToTop'
import RequireAuth from '../components/RequireAuth'
import Page404 from './Page404'
import { getOneCompanyBySlug } from '../store/actions/company'
import PageLoader from '../components/PageLoader'

const AppRoutes = lazy(() => import('./App'))
const SignUp = lazy(() => import('./SignUp'))
const SignIn = lazy(() => import('./SignIn'))
const SignOut = lazy(() => import('./SignOut'))
const AccountRecovery = lazy(() => import('./AccountRecovery'))
const ForgotPassword = lazy(() => import('./ForgotPassword'))
const Invitation = lazy(() => import('./Invitation'))

function getSubdomainFromUrl(url = window.location.href) {
  const hostname = new URL(url).hostname
  const parts = hostname.split('.')
  return parts[0] || null
}

const Component = () => {
  const dispatch = useDispatch<Dispatch<Action>>()

  useEffect(() => {
    const subDomain = getSubdomainFromUrl()

    if (subDomain) {
      dispatch(getOneCompanyBySlug({ slugCompany: subDomain }))
    }
  }, [])

  return (
    <BrowserRouter>
      <ScrollToTop useLocation={useLocation} />

      <Routes>
        <Route
          path='/app/*'
          element={
            <RequireAuth>
              <AppRoutes />
            </RequireAuth>
          }
        />

        <Route path='/' element={<AuthLayout />}>
          <Route index element={<Navigate to='sign-in' />} />

          <Route path='sign-up' element={
            <Suspense fallback={<PageLoader />}>
              <SignUp />
            </Suspense>
          } />

          <Route path='sign-in' element={
            <Suspense fallback={<PageLoader />}>
              <SignIn />
            </Suspense>
          } />

          <Route path='sign-out' element={
            <Suspense fallback={<PageLoader />}>
              <SignOut />
            </Suspense>
          } />

          <Route path='account-recovery' element={
            <Suspense fallback={<PageLoader />}>
              <AccountRecovery />
            </Suspense>
          } />

          <Route path='forgot-password' element={
            <Suspense fallback={<PageLoader />}>
              <ForgotPassword />
            </Suspense>
          } />

          <Route path='invitation/:idInvitation' element={
            <Suspense fallback={<PageLoader />}>
              <Invitation />
            </Suspense>
          } />

          <Route path='*' element={<Page404 />} />
        </Route>

        <Route path='*' element={<Page404 />} />
      </Routes>
    </BrowserRouter>
  )
}

export default Component
